import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { SnWidget } from '@lib/api/entities';
import { SnOperationalViewsAPI } from '@lib/api/services';
import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'sn-embed-code-widget',
  templateUrl: './embed-code-widget.component.html',
  styleUrls: ['./embed-code-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmbedCodeWidgetComponent implements OnInit, OnDestroy {
  @Input() public widget: SnWidget;
  @Input() public viewId: string;
  public embedCode: string;
  public editCode: boolean;
  public clearCode: SafeHtml;
  public changeTitle: boolean;

  public form: UntypedFormGroup = new UntypedFormGroup({});
  public formModel: any = {};

  public formFields: SnFormFieldConfig[];
  private readonly _destroy$ = new Subject<void>();

  constructor(
    private readonly _operationalViewsAPI: SnOperationalViewsAPI,
    private readonly _cd: ChangeDetectorRef,
    private readonly _sanitizer: DomSanitizer,
  ) {}

  public ngOnInit(): void {
    this._initFields();
    this.clearCode = this.widget.meta.embedCode
      ? this._sanitizer.bypassSecurityTrustHtml(this.widget.meta.embedCode)
      : '';

    if (this.widget.meta.embedCode) {
      this._patchForm(this.widget.meta.embedCode);
    }
    this._cd.detectChanges();
  }

  public editTitle(): void {
    this.changeTitle = true;
  }

  public setTitle(value: boolean): void {
    this.changeTitle = value;
    this._cd.detectChanges();
  }

  public setUpdateTitle(value: string): void {
    this.widget.name = value;
    this._cd.detectChanges();
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  public submitForm(): void {
    const embedCode = this.formModel.embedCode;
    this._operationalViewsAPI
      .updateViewWidget(this.viewId, this.widget.id, { meta: { embedCode } })
      .pipe(takeUntil(this._destroy$))
      .subscribe();
    this.widget.meta.embedCode = embedCode;
    this.clearCode = this._sanitizer.bypassSecurityTrustHtml(this.widget.meta.embedCode);
    this.editCode = false;
    this._cd.detectChanges();
  }

  private _initFields(): void {
    this.formFields = [
      {
        key: 'embedCode',
        type: 'textarea',
        templateOptions: {
          label: t('dashboard.operational.widgets.embedCode'),
          floatLabel: 'always',
          autosize: true,
          autosizeMinRows: 1,
          autosizeMaxRows: 3,
          rows: 5,
          appearance: 'outline',
          height: '150px',
          required: true,
        },
      },
    ];
  }

  private _patchForm(embedCode: string): void {
    this.formModel.embedCode = embedCode;
  }
}
